<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between justify-content-md-end align-content-center">
    

        <a class=" d-flex align-items-center  text-secondary f18 my-auto dirI text-white"><span >
            مدیریت SOS ها  </span></a>
    </div>
</div>
<div class="col-12 d-flex justify-content-around mt-2 dirI flex-wrap">
    <div class="col-12 d-flex flex-wrap justify-content-start">
        <div class="col-md-3 col-6  dirI">
            <div class="col-11 mx-auto">

                <label class="mb-2"> تاریخ</label>
                <form [formGroup]="datatFrom">
                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                        <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                    </ng-persian-datepicker>
                </form>
            </div>
        </div>
     
        <div class="col-md-3 col-6  dirI">
            <div class="col-11 mx-auto">

                <label class="mb-2"> حوزه خدمت</label>
                <select class="form-select" id="domainDashbord">
                    <option value="-1">انتخاب کنید</option>
                    <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
                </select>
            </div>

        </div>
        <div class="col-md-3 col-6  dirI">
            <div class="col-11 mx-auto">

                <label class="mb-2">  ساعت</label>
                <div class="input-group clockpicker">

                    <input type="text" class="form-control shadow bg-light" readonly value="00:00" id="sTime">
                    <span class="input-group-addon ">
                <span class="glyphicon glyphicon-time"></span>
                    </span>
                </div>
            </div>
        </div>
     
        <div class="col-md-3 col-6  dirI d-flex align-items-end justify-content-start">
            <button class="btn btn-primary" (click)="search()">جستجو</button>
        </div>
        <div class="col-md-3 col-6 col-md-3 dirI d-flex flex-wrap justify-content-between">
            <div class="d-flex flex-row align-items-center">
                <i class="fa fa-file-excel-o text-success fa-2x pointer" (click)="exportexcel('liveJournal')" title="خروجی اکسل"></i>
            </div>
            <div class="d-flex flex-row align-items-center">
                <label for="show-last-th">نمایش آخرین ستون</label>
                <input type="checkbox" class="form-check" id="show-last-th" checked>
            </div>

        </div>
    </div>

</div>
<hr class="w-100">
<div style="height: 75vh; overflow-y: auto;" id="scroll-handel">
    <table class="table mt-1 dirI table-striped f12" id="liveJournal">
        <thead class=" dirI ">
            <tr class="text-center ">
                <th scope="col " class=""># </th>
                <th scope="col" class="">عملیات</th>
                <th scope="col" class="">تاریخ </th>
                <th scope="col" class="">ساعت  </th>

                <th scope="col" class="">نام و نام خانوادگی </th>
                <th scope="col" class="">موبایل </th>
                <th scope="col" class="">حوزه خدمت </th>


            </tr>
        </thead>
        <tbody>
            <tr class="text-center  dirI " *ngFor="let item of SosData;let i=index">
                <th class="">{{i+1}}</th>
                <th class=""><img class="pointer" width="22" height="22" src="../../../assets/Img/polygon-icon-28-min.png">
                </th>
                <th class="">{{item.strDate}}</th>
                <th class="">{{item.strTime}}</th>
                <th class="">{{item.strFullName}}</th>
                <th class="">{{item.strFullName}}</th>
                <th class="">{{item.strMobile}}</th>
                <th class="">{{item.strMobileDomain_strComment}}</th>
            </tr>

        </tbody>
    </table>
</div>


<!--Modal-->
<div class="modal" id="map" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">نقشه</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div id="map-modal" class="position-sticky w-100" style="height: 400px;">
                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>